import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { metricLengthToFormattedImperial } from '@inter-ikea-guida/framework';
import { useKompis } from '../../contexts';
import { getTranslation } from '../../store/i18n/selectors';
const DOUBLE_PRIME_SIGN = '″';
export const FormattedMeasurement = ({ cm, toInches, withDoublePrime }) => {
    const translate = useSelector(getTranslation);
    const { translations } = useKompis();
    return (_jsx(_Fragment, { children: getFormattedMeasurement(cm, translate, toInches, withDoublePrime, translations.kompis) }));
};
export const getFormattedMeasurement = (cm, translator, toInches, withDoublePrime, kompisTranslations) => {
    const unitLabel = toInches
        ? withDoublePrime
            ? DOUBLE_PRIME_SIGN
            : translator('guid01Inches')
        : translator('Common.MeasureValueCm');
    const formattedMeasurement = toInches
        ? metricLengthToFormattedImperial(cm, kompisTranslations)
        : cm;
    return `${formattedMeasurement} ${unitLabel}`;
};
//# sourceMappingURL=FormattedMeasurement.js.map